export default {"src":"/_next/static/media/lun.130e1cd8.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};